import { GoogleMapsScriptProtocol, LAZY_MAPS_API_CONFIG, LazyMapsAPILoaderConfigLiteral, MapsAPILoader } from '@agm/core';
import { DocumentRef, WindowRef } from '@agm/core/utils/browser-globals';
import { Inject, Injectable } from '@angular/core';

//import { AppGlobals } from './../../Common/Services/app.global';

import { Configuration } from './index.model';

import { environment } from '../../environments/environment';

import * as Services from './index.service';

import { HttpHeader } from '../core/httpheader';
import { Http, RequestOptions } from '@angular/http';
import {
    SessionStorageService, ParameterConfigService
} from '../core/index.service';


import { ParamInfo } from '../core/index.model';

import data from '../../assets/config/config.json'

@Injectable()
export class CustomLazyAPIKeyLoader implements LazyMapsAPILoaderConfigLiteral {
    //public apiKey: string;
    public libraries: string[];
    public channel: string;
    public clientId: string;

    private requestHeader: HttpHeader = new HttpHeader();
    private Http_Header_Request_Options: RequestOptions;

    constructor(
        private configService: Services.ConfigService,
        private http: Http,
        private storageService: SessionStorageService
    ) {
        if (environment.production) {

            this.libraries = ['places', 'visualization','geometry'];

            // ---------------   commented for Path reference test ------------------
            this.http.get(environment.configFile, this.Http_Header_Request_Options).map(res => res.json())
               .subscribe(config => {
                   this.clientId = config["ClientID"];
               });
            //---------------------------------------------------------

            // this.clientId = data["ClientID"]; // added for Path reference test

            this.channel = 'CSP_' + this.storageService.getJurisNo() + "_" + this.storageService.getJurisName();
        }
    }
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/MapApiClass.ts